// Estas claves se asignan por tienda desde custom_design_settings.
export const CLIENT_THEMES = {
  'libreria-regaleria': 'libreria-regaleria',
};

export const getClientTheme = (client) => (
  CLIENT_THEMES[client?.custom_design_settings?.theme] || null
);
